import { render } from "./ThePatientPersonalDataModal.vue?vue&type=template&id=b8dde29e&ts=true"
import script from "./ThePatientPersonalDataModal.vue?vue&type=script&lang=ts"
export * from "./ThePatientPersonalDataModal.vue?vue&type=script&lang=ts"

import "./ThePatientPersonalDataModal.vue?vue&type=style&index=0&id=b8dde29e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__